import axios from 'axios';

const API_KEY = '76c425f83d3dd4a696721e5d4d4cc3fe';

export const getWeather = (city) => {
  return axios.get(`https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=${API_KEY}&units=metric`);
};

export const getWeatherNextDays = (city) => {
  return axios.get(`https://api.openweathermap.org/data/2.5/forecast?q=${city}&appid=${API_KEY}&units=metric`);
};
